import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { fetch_All_Late_count_monthly, fetchAll_late_count, fetchAll_late_Report } from "../../../core/data/redux/reports/late_detail_report/late_detail_Action";

interface EmployeeReportProps {
  status?: "active" | "inactive";
  department?: string;
  project?: string;
  showOnlyTable?: boolean;
}

type MonthlyLateCount = {
  month: any;
  late_employee_count: any;
};


const Late_details_Reports: React.FC<EmployeeReportProps> = ({ status, department, project, showOnlyTable }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { employees } = useSelector((state: any) => state.employee);
  const [lateData, setlateData] = useState<any>([]);
  const [Count, setCount] = useState<any>({});
  const [monthlycount, setmonthlycount] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // you can change this


  const getCurrentMonthDates = () => {
    const now = new Date();

    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const format = (date: Date) => date.toISOString().split("T")[0];

    return {
      startDate: format(start),
      endDate: format(end),
    };
  };

  const { startDate: defaultStartDate, endDate: defaultEndDate } =
    getCurrentMonthDates();

  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);



  const handleSearch = async () => {
    if (!startDate || !endDate) {
      alert('Please select both Start Date and End Date');
      return;
    }

    try {
      const lateListRes = await dispatch(
        fetchAll_late_Report({
          StartDate: startDate,
          EndDate: endDate,
        })
      ).unwrap();

      const lateCountRes = await dispatch(
        fetchAll_late_count({
          StartDate: startDate,
          EndDate: endDate,
        })
      ).unwrap();

      const MonthlyCount = await dispatch(fetch_All_Late_count_monthly({
        StartDate: startDate,
        EndDate: endDate,
      })
      ).unwrap();

      setlateData(lateListRes.data);
      setCount(lateCountRes.data);
      setmonthlycount(MonthlyCount.data)

    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    dispatch(getEmployees());
  }, [dispatch])


  function filterReportData(data: any[]) {
    return lateData.map((emp : any)  => ({
      Name: emp.EmployeeName || "N/A",
      Employee_Number: emp.EmployeeNumber || "N/A",
      PunchDate: emp.PunchDate || "N/A",
      LoginTime: emp.LoginTime || "N/A",
      ShiftName: emp.ShiftName || "N/A",
      ShiftMaxStartTime: emp.ShiftMaxStartTime || "N/A",
      LateBy: emp.LateBy || "N/A",
    }));
  }

  const dataforExport = filterReportData(lateData)
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");

  /* ------------------ Employee Map (Fast Lookup) ------------------ */
  const employeeMap = useMemo(() => {
    const map: any = {};
    employees?.forEach((emp: any) => {
      map[emp.EmployeeID] = emp;
    });
    return map;
  }, [employees]);

  /* ------------------ Department List ------------------ */
  const departments = useMemo(() => {
    const set = new Set<string>();
    employees?.forEach((emp: any) => {
      if (emp.department_name) set.add(emp.department_name);
    });
    return Array.from(set);
  }, [employees]);

  /* ------------------ Filtered Data ------------------ */
  const filteredData = useMemo(() => {
    return lateData.filter((item: any) => {
      const emp = employeeMap[item.EmployeeID];

      if (!emp) return false;

      const matchEmployee =
        !selectedEmployee || item.EmployeeID === Number(selectedEmployee);

      const matchDepartment =
        !selectedDepartment ||
        emp.department_name === selectedDepartment;

      return matchEmployee && matchDepartment;
    });
  }, [lateData, selectedEmployee, selectedDepartment, employeeMap]);


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage]);


  useEffect(() => {
    setCurrentPage(1);
  }, [filteredData]);


useEffect(() => {
  if (!monthlycount || monthlycount.length === 0) return;

  const monthlyCounts = Array.from({ length: 12 }, () => 0);

  (monthlycount as MonthlyLateCount[]).forEach(item => {
    const monthNum = Number(item.month); // 🔑 IMPORTANT
    const index = monthNum - 1;

    if (index >= 0 && index < 12) {
      monthlyCounts[index] = Number(item.late_employee_count);
    }
  });

  setEmployeechart((prev : any) => ({
    ...prev,
    series: [
      {
        name: "Late Employees", 
        data: [...monthlyCounts], 
      },
    ],
  }));
}, [monthlycount]);


  const [employeechart, setEmployeechart] = useState<any>({
    series: [
      {
        name: "Employees",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      type: "bar",
      height: 180,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    colors: ["#03C95A", "#E8E9EA"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: function (val: string) {
          return val + " Employee";
        },
      },
    },
  });

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Late Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Late Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(dataforExport, "late_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(dataforExport, "late_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(dataforExport, "late_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-12">
              {/* Parent Card */}
              <div className="card">
                {/* Header with Date Filters */}
                <div className="card-header">
                  <div className="row align-items-end g-2">
                    <div className="col-md-3">
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3">
                      <button
                        className="btn btn-primary w-100"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>

                {/* Body */}
                <div className="card-body">
                  <div className="row">
                    {/* LEFT SIDE – Four Boxes */}
                    <div className="col-xl-6">
                      <div className="row">
                        {/* Total Employee */}
                        <div className="col-md-6 mb-3">
                          <div className="card h-100">
                            <div className="card-body">
                              <p className="mb-1">Late Employee</p>
                              <h5>{ Count ? Count?.[0]?.late_employee_count : "00"}</h5>
                              <span className="me-2">
                                <ImageWithBasePath
                                  src="assets/img/reports-img/employee-report-icon.svg"
                                  alt="Img"
                                  className="img-fluid"
                                />
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Active Employee */}
                        <div className="col-md-6 mb-3">
                          <div className="card h-100">
                            <div className="card-body">
                              <p className="mb-1">Total Employee</p>
                              <h5>{Count ? Count?.[0]?.total_active_employee_count : "00"}</h5>
                              <span className="me-2">
                                <ImageWithBasePath
                                  src="assets/img/reports-img/employee-report-icon.svg"
                                  alt="Img"
                                  className="img-fluid"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* RIGHT SIDE – Chart */}
                    <div className="col-xl-6">
                      <div className="card h-100">
                        <div className="card-header border-0">
                          <h5>Number of Late Employee Each Month</h5>
                        </div>
                        <div className="card-body">
                            <ReactApexChart
                              options={employeechart}
                              series={employeechart.series}
                              type="bar"
                              height={220}
                            />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3"></div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="card shadow-sm border-0">
                {/* ================= Filters ================= */}
                <div className="card-header bg-white">
                  <div className="row g-2 align-items-end">
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">
                        Filter by Employee
                      </label>
                      <select
                        className="form-select"
                        value={selectedEmployee}
                        onChange={(e) => setSelectedEmployee(e.target.value)}
                      >
                        <option value="">All Employees</option>
                        {employees?.map((emp: any) => (
                          <option key={emp.EmployeeID} value={emp.EmployeeID}>
                            {emp.Name} ({emp.EmployeeNumber})
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-semibold">
                        Filter by Department
                      </label>
                      <select
                        className="form-select"
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                      >
                        <option value="">All Departments</option>
                        {departments.map((dept) => (
                          <option key={dept} value={dept}>
                            {dept}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 text-end">
                      <button
                        className="btn btn-outline-secondary mt-4"
                        onClick={() => {
                          setSelectedEmployee("");
                          setSelectedDepartment("");
                        }}
                      >
                        Reset Filters
                      </button>
                    </div>
                  </div>
                </div>

                {/* ================= Table ================= */}
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Employee</th>
                          <th>Department</th>
                          <th>Date</th>
                          <th>Login Time</th>
                          <th>Shift</th>
                          <th>Max Start</th>
                          <th className="text-danger">Late By</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredData.length === 0 ? (
                          <tr>
                            <td colSpan={8} className="text-center py-4 text-muted">
                              No late login records found
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((item: any, index: number) => {
                            const emp = employeeMap[item.EmployeeID];
                            return (
                              <tr key={index}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td>
                                  <div className="fw-semibold">
                                    {item.EmployeeName}
                                  </div>
                                  <small className="text-muted">
                                    {item.EmployeeNumber}
                                  </small>
                                </td>
                                <td>{emp?.department_name || "-"}</td>
                                <td>
                                  {new Date(item.PunchDate).toLocaleDateString()}
                                </td>
                                <td>{item.LoginTime}</td>
                                <td>{item.ShiftName}</td>
                                <td>{item.ShiftMaxStartTime}</td>
                                <td className="fw-semibold text-danger">
                                  {item.LateBy}
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center p-3 border-top">
                    <span className="text-muted">
                      Page {currentPage} of {totalPages}
                    </span>

                    <nav>
                      <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(prev => prev - 1)}
                          >
                            Previous
                          </button>
                        </li>

                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                          <li
                            key={page}
                            className={`page-item ${currentPage === page ? "active" : ""}`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          </li>
                        ))}

                        <li
                          className={`page-item ${currentPage === totalPages ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(prev => prev + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default Late_details_Reports;
